import { Task } from './columns-tasks';
import type { MatterMember } from '@/types/base';
import { TaskFormDialog } from './task-form-dialog';

interface CreateTaskDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateTask: (task: Omit<Task, 'id' | 'created_by' | 'state'>) => void;
  availableTasks: Task[];
  members?: MatterMember[];
}

export const CreateTaskDialog = ({
  isOpen,
  onClose,
  onCreateTask,
  availableTasks,
  members = [],
}: CreateTaskDialogProps) => {
  return (
    <TaskFormDialog
      mode="create"
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onCreateTask}
      members={members}
      availableTasks={availableTasks}
    />
  );
};
